export const RankingNegative = () => {
  return (
    <svg fill="none" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99997 7.99997L5 5M5 5L2 2M5 5L8 2M5 5L2 8"
        stroke="#FF4050"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </svg>
  );
};
